/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import PropTypes from 'prop-types';

function InputField({
  name = '',
  value = undefined,
  placeholder = '',
  type = 'text',
  fieldType = '',
  onChange = () => {},
  onBlur = () => {},
  onKeyUp = () => {},
  options = [<option value="">Vilaj</option>],
  className = 'tv-field__input',
  ...rest
}) {
  if (fieldType === 'select') {
    return (
      <select
        name={name}
        value={value}
        className={`${className}`}
        onChange={onChange}
      >
        {options}
      </select>
    );
  }
  return (
    <input
      name={name}
      value={value}
      className={`${className}`}
      placeholder={placeholder}
      type={type}
      onKeyUp={onKeyUp}
      onChange={onChange}
      onBlur={onBlur}
      {...rest}
    />
  );
}

InputField.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  fieldType: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyUp: PropTypes.func,
  options: PropTypes.node,
  style: PropTypes.shape({}),
  className: PropTypes.string,
};

export default InputField;
